/**
 * Cap-bucket segmentation table for one signal:
 * Q5-Q1 spread and IC per market-cap segment (3M horizon, both benchmarks).
 */
import React from "react";
import { AlphaVal, SigBadge } from "./common";

export const CAP_LABELS = { big: "Large Cap", mid_small: "Mid / Small", micro: "Micro" };

export const CapBucketBlock = ({ capData, testIdPrefix }) => {
  if (!capData || Object.keys(capData).length === 0) return null;
  const buckets = ["big", "mid_small", "micro"].filter((b) => capData[b]);
  if (!buckets.length) return null;

  return (
    <div className="mt-4" data-testid={`${testIdPrefix}-capsplit`}>
      <div className="text-sm font-medium mb-2">
        By market cap segment{" "}
        <span className="text-muted-foreground font-normal">(3M horizon)</span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-xs border rounded-lg">
          <thead>
            <tr className="border-b text-muted-foreground bg-muted/30">
              <th className="text-left py-2 px-3 font-medium">Segment</th>
              <th className="text-right py-2 px-3 font-medium">Q5−Q1 vs Sector</th>
              <th className="text-right py-2 px-3 font-medium">IC vs Sector</th>
              <th className="text-right py-2 px-3 font-medium">Q5−Q1 vs SPY</th>
              <th className="text-right py-2 px-3 font-medium">IC vs SPY</th>
            </tr>
          </thead>
          <tbody>
            {buckets.map((b) => {
              const sec = capData[b]?.sector || {};
              const spy = capData[b]?.spy || {};
              return (
                <tr key={b} className="border-b last:border-0 hover:bg-muted/30">
                  <td className="py-2 px-3 font-medium">{CAP_LABELS[b]}</td>
                  <td className="text-right py-2 px-3">
                    <AlphaVal value={sec.spread?.mean_pct} />
                    <span className="text-muted-foreground ml-1">
                      (t={sec.spread?.nw_tstat ?? "-"})
                    </span>{" "}
                    <SigBadge t={sec.spread?.nw_tstat} />
                  </td>
                  <td className="text-right py-2 px-3 font-mono">
                    {sec.ic?.mean_ic ?? "-"}
                    <span className="text-muted-foreground ml-1">(t={sec.ic?.nw_tstat ?? "-"})</span>
                  </td>
                  <td className="text-right py-2 px-3">
                    <AlphaVal value={spy.spread?.mean_pct} />
                    <span className="text-muted-foreground ml-1">
                      (t={spy.spread?.nw_tstat ?? "-"})
                    </span>{" "}
                    <SigBadge t={spy.spread?.nw_tstat} />
                  </td>
                  <td className="text-right py-2 px-3 font-mono">
                    {spy.ic?.mean_ic ?? "-"}
                    <span className="text-muted-foreground ml-1">(t={spy.ic?.nw_tstat ?? "-"})</span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
